import { render, staticRenderFns } from "./PortalResults.vue?vue&type=template&id=e79e6428&scoped=true&"
import script from "./PortalResults.vue?vue&type=script&lang=js&"
export * from "./PortalResults.vue?vue&type=script&lang=js&"
import style0 from "./PortalResults.vue?vue&type=style&index=0&id=e79e6428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79e6428",
  null
  
)

export default component.exports